<app-page-title [title]="id ? 'Alterar célula' : 'Cadastrar célula'"></app-page-title>
<div class="form-container">
  <form [formGroup]="form">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nome</mat-label>
      <input class="input" matInput placeholder="Nome" formControlName="name" />
      <mat-error *ngIf="form.controls.name.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>
    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Setor</mat-label>
      <mat-select formControlName="sector_id">
        <mat-option *ngFor="let sector of sectores" [value]="sector.id">
          {{ sector.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.sector_id.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Dia</mat-label>
      <mat-select formControlName="day">
        <mat-option value="Segunda-feira">Segunda-feira </mat-option>
        <mat-option value="Terça-feira">Terça-feira </mat-option>
        <mat-option value="Quarta-feira">Quarta-feira </mat-option>
        <mat-option value="Quinta-feira">Quinta-feira</mat-option>
        <mat-option value="Sexta-feira">Sexta-feira</mat-option>
        <mat-option value="Sábado">Sábado</mat-option>
        <mat-option value="Domingo">Domingo</mat-option>
      </mat-select>
    </mat-form-field>
    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Horario</mat-label>
      <input type="time" class="input" matInput placeholder="Horario" formControlName="hour" />
    </mat-form-field>
    <br />

    <button *ngIf="!id" (click)="add()" mat-raised-button class="btn-primary">Cadastrar</button>

    <button *ngIf="id" (click)="save()" class="btn-primary" mat-raised-button>Salvar</button>
  </form>
</div>
